module.exports = __webpack_public_path__ + "img/css3.8d8eb0fc.png";